import React, { useState }from 'react'
import { createQuickSortCodeMap } from '../../codemapping/createQuickSortCodeMap';

import { QuickSortContext } from "../../statepattern/QuickSortContext";
import { QuickSortInitState } from '../../statepattern/states/quicksort/QuickSortInitState';
import { QuickSortStep } from '../../statepattern/enums/QuickSortStep'

import styled from "styled-components";
import { AlgoStackComponent } from '../../algostack/AlgoStackComponent';
import { QuickSortContainer } from '../partition/QuickSortContainer';
import { QuickSortCodelines } from '../codelines/QuickSortCodelines';

const StyledHomeContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;

  padding: 3px;
`;

let entryState = new QuickSortInitState();
let pactx = new QuickSortContext(entryState);

let codemap : Map<QuickSortStep, number> = createQuickSortCodeMap();

interface QuickSortHomeProps {
  milliseconds? : number | undefined,
  play?: boolean | undefined,
  rewind?: boolean | undefined
}

export function QuickSortHome ({
  milliseconds,
  play,
  rewind,
} : QuickSortHomeProps)  {

  const [StepName, setStepName] = useState(pactx.StepName);
  const [HI, setHI] = useState(pactx.Hi);
  const [LO, setLO] = useState(pactx.Lo);
  const [Pivot, setPivot] = useState(pactx.Pivot);
  const [ICount, setICount] = useState(pactx.ICount);
  const [JCount, setJCount] = useState(pactx.JCount);
  const [Numbers, setNumbers] = useState(pactx.Numbers);
  const [PartitionIndex, setPartitionIndex] = useState(pactx.PartitionIndex);
  const [QuickSortStep, setQuickSortStep] = useState(pactx.ContextQuickSortStep);
  const [AlgoStack, setAlgoStack] = useState(pactx.AlgoStack);
  const [SortedIndices, setSortedIndices] = useState(pactx.SortedIndices);

  const [SkipPartitionStepFlagChecked, setSkipPartitionStepFlagChecked] = useState(pactx.SkipPartition)

  const stepForward = () => {
    pactx.StepForward();
    setHI(pactx.Hi);
    setLO(pactx.Lo);
    setPivot(pactx.Pivot);
    setICount(pactx.ICount);
    setJCount(pactx.JCount);
    setPartitionIndex(pactx.PartitionIndex);
    setNumbers(pactx.Numbers);
    setStepName(pactx.StepName);
    setQuickSortStep(pactx.ContextQuickSortStep);
    setAlgoStack(pactx.AlgoStack);
    setSortedIndices(pactx.SortedIndices);
  }

  const stepBackward = () => {
    pactx.StepBackward();
    setHI(pactx.Hi);
    setLO(pactx.Lo);
    setPivot(pactx.Pivot);
    setICount(pactx.ICount);
    setJCount(pactx.JCount);
    setPartitionIndex(pactx.PartitionIndex);
    setNumbers(pactx.Numbers);
    setStepName(pactx.StepName);
    setQuickSortStep(pactx.ContextQuickSortStep);
    setAlgoStack(pactx.AlgoStack);
    setSortedIndices(pactx.SortedIndices);
  }

  const ToggleSkipPartitionStepFlag = () => {
    if (SkipPartitionStepFlagChecked) {
      pactx.SkipPartition = false;
      setSkipPartitionStepFlagChecked(false);      
    } else {
      pactx.SkipPartition = true;
      setSkipPartitionStepFlagChecked(true);
    }
  }

  React.useEffect(() => {
    if (play) {
      const id = setInterval(stepForward, milliseconds);
      return () => {
        clearInterval(id);
      }
    };
  }, [milliseconds, play])

  React.useEffect(() => {
    if (rewind) {
      const id = setInterval(stepBackward, milliseconds);
      return () => {
        clearInterval(id);
      }
    };
  }, [milliseconds, rewind])

  return (
    <div>
      <div>
        <form>
          <input type='checkbox' id='skipPartitionStepFlag'
            checked={SkipPartitionStepFlagChecked}
            onChange={() => ToggleSkipPartitionStepFlag()}
          />
          <label htmlFor='skipPartitionStepFlag'>Skip Partition Step</label>
        </form>
      </div>
      <StyledHomeContainer>
        <QuickSortCodelines Highlighted={codemap.get(QuickSortStep)}/>
        <QuickSortContainer
          StepName={StepName}
          Numbers={Numbers}
          LO={LO} 
          HI={HI}
          Pivot={Pivot}
          ICount={ICount}
          JCount={JCount}
          PartitionIndex={PartitionIndex}
          StepForward={stepForward}
          StepBackward={stepBackward}
          SortedIndices={SortedIndices}
        />
        <AlgoStackComponent AlgoStack={AlgoStack} />
      </StyledHomeContainer>
    </div>

  )
}
